import NextImage from "../../lib/NextImage";
import BaseOption from "./base-checkbox/BaseOption";

interface Props {
  selected: boolean;
  toggleOption: () => void;
  image_src: string;
  disabled?: boolean;
  is_multi_select: boolean;
  label: string;
}

const ImageOption: React.FC<Props> = ({
  selected,
  toggleOption,
  image_src,
  label,
  disabled = false,
  is_multi_select,
}) => {
  return (
    <div
      onClick={disabled ? () => {} : toggleOption}
      className={`product-add-on ${selected ? "checked" : ""}`}
    >
      <div className="add-on-image">
        <NextImage alt="" src={image_src} objectFit="fill" />
      </div>
      <BaseOption
        disabled={disabled}
        selected={selected}
        toggleOption={toggleOption}
        is_multi_select={is_multi_select}
        label={label}
      />
    </div>
  );
};

export default ImageOption;
